<template>
  <div>
    <div class="container tablet-container" v-if="headerOptions && headerOptions.showBlankHeader">
      <div class="row profile-header header-style">
        <LanguageCountry v-if="headerOptions.showCountryLanguages" :languageId="portal.getLanguage()" :countryId="portal.getCountry()" :mode="'NAV'"></LanguageCountry>
        <div v-if="headerOptions.eventHandler" class="col-md-3 col-2 pl-0 d-flex align-items-center">
          <a class="cursor-pointer" @click="typeof headerOptions.eventHandler === 'string' ? $root.$emit(headerOptions.eventHandler) : headerOptions['eventHandler']()"><i class="fa fa-angle-left fs-29"></i></a>
        </div>
        <div v-else-if="headerOptions.backRouterLink" class="col-md-3 col-2 pl-0 d-flex align-items-center">
          <a class="cursor-pointer" @click="onClickBackBtnSamePage(backBtnLinkOptions)"><i class="fa fa-angle-left fs-29"></i></a>
        </div>
        <div v-else-if="!headerOptions.hideBack" class="col-md-3 col-2 pl-0 d-flex align-items-center">
          <a class="cursor-pointer" @click="onBackBtnClick"><i class="fa fa-angle-left fs-29"></i></a>
        </div>
        <div v-else-if="headerOptions.hideBack" class="col-md-3 col-2 pl-0 d-flex align-items-center justify-content-center"></div>
        <div class="col-md-6 col-8 text-center global-activity-title">
          {{ headerOptions.title }}
        </div>
        <div v-if="!headerOptions.hideCancel" class="col-md-3 col-2 pr-0 global-cancel-text d-flex justify-content-end align-items-center" data-toggle="modal" data-target="#activity_cancel_Modal1">
          <a class="cursor-pointer" @click="onCancelClick" v-translate:label_cancel="lang">Cancel</a>
        </div>
      </div>
    </div>
    <div class="container tablet-container" v-if="participant.active && isLoginRouteName">
      <div class="row profile-header header-style">
        <div class="col-md-2 pl-0">
          <div v-translate:need_help.title="lang" title="Need Help?" class="icon cursor_pointer help-icon mr-14" @click.prevent="onParticipantAddress()">
            <svg class="mt-5" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
              <path
                fill="var(--primary)"
                d="M31.11 6.8C29.086 2.392 25.62.148 20.801.033c-2.166-.06-4.326-.022-6.49-.003-1.468.013-2.96-.08-4.39.14C5.189.896 2.066 3.618.603 8.157c-.774 2.404-.713 4.93-.32 7.373.73 4.42 3.364 7.373 7.565 8.89.737.227 1.484.418 2.24.57v.32c0 1.52-.016 3.043 0 4.562 0 .383.088.762.256 1.106.66 1.221 2.256 1.375 3.232.32 1.786-1.9 3.575-3.808 5.325-5.738.154-.198.355-.355.585-.457.23-.101.48-.145.73-.126 1.454.077 2.91-.134 4.282-.62 1.373-.488 2.636-1.24 3.718-2.217 2.07-1.834 3.376-4.129 3.664-6.892.122-1.573.151-3.152.087-4.728-.025-1.286-.318-2.552-.858-3.719zM16.321 20.828c-.346.007-.686-.09-.977-.277-.291-.188-.52-.458-.657-.776-.137-.319-.176-.67-.112-1.011.063-.341.227-.655.47-.902.242-.247.553-.417.892-.486.339-.07.691-.036 1.011.096.32.131.594.356.786.644.192.289.294.628.293.974.002.457-.176.896-.495 1.222-.32.325-.755.51-1.211.516zm1.357-6.95c-.076.034-.14.09-.18.163-.042.072-.06.155-.05.238.015.542 0 1.083 0 1.654h-2.673c0-.083-.019-.164-.019-.244v-2.654c-.003-.07.017-.14.056-.198.04-.058.098-.1.165-.123.923-.403 1.726-1.038 2.333-1.843.326-.422.552-.913.662-1.436.103-.46.025-.942-.218-1.346-.244-.404-.633-.698-1.087-.82-1.165-.337-2.32.236-2.605 1.297-.042.164-.064.32-.096.513h-2.733c.046-.401.112-.8.198-1.195.264-.93.809-1.756 1.56-2.364.75-.608 1.67-.97 2.632-1.034 1.098-.099 2.197.188 3.107.811.91.624 1.575 1.545 1.882 2.606.278.989.181 2.046-.272 2.968-.556 1.252-1.483 2.302-2.656 3.007h-.006z"
              />
            </svg>
          </div>
          <div class="help-container-relative">
            <div class="help-container" v-if="seen" v-clickoutside="hide">
              <div class="help-nameText">{{ getSiteName }}</div>
              <div class="help-addressText">{{ getAddress }}</div>
              <div v-if="participantAddress.type == 'Physical'">
                <a class="help_call_studySite btn" v-translate:call_study_site="lang" @click="onCallStudySite()">Call Study Site</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 menu_header" v-if="participant.active">
          <ul class="nav justify-content-center">
            <li class="nav-item mr-30 active">
              <span class="nav-link" :class="$route.path.includes('activity/') ? 'participant-portal-active-link' : ''" @click="activityPage('activity')">
                <svg data-v-039e0196="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 29 29" class="header-menu_icons dashboard_icon">
                  <g>
                    <g stroke="null" id="svg_1">
                      <g fill="#9B9B9B" id="svg_2">
                        <path
                          stroke="null"
                          id="svg_3"
                          d="m14.58266,0.54154c-7.64351,0 -13.86194,6.21834 -13.86194,13.86176s6.21843,13.86176 13.86194,13.86176c7.64342,0 13.86176,-6.21834 13.86176,-13.86176s-6.21834,-13.86176 -13.86176,-13.86176zm0,25.45109c-6.3905,0 -11.58952,-5.19884 -11.58952,-11.58934c0,-6.39041 5.19902,-11.58934 11.58952,-11.58934c6.39041,0 11.58934,5.19893 11.58934,11.58934c0,6.3905 -5.19893,11.58934 -11.58934,11.58934z"
                        />
                        <path
                          stroke="null"
                          id="svg_4"
                          d="m20.57921,9.08302l-8.23034,8.23043l-3.76294,-3.76294c-0.44376,-0.44367 -1.16312,-0.44367 -1.60687,0c-0.44367,0.44376 -0.44367,1.16312 0,1.60687l4.56638,4.56638c0.22188,0.22179 0.51266,0.33277 0.80344,0.33277c0.29078,0 0.58156,-0.11098 0.80344,-0.33277l9.03377,-9.03377c0.44367,-0.44376 0.44367,-1.16312 0,-1.60687c-0.44376,-0.44376 -1.16321,-0.44376 -1.60687,-0.00009z"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
                <span v-translate:ACTIVITIES_TITLE="lang">Activities</span>
              </span>
            </li>
            <li class="nav-item mr-30">
              <span class="nav-link" :class="$route.name == 'participants-portal-dashboard' ? 'participant-portal-active-link' : ''" @click="dashboardPage()">
                <svg class="header-menu_icons dashboard_icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 28 28">
                  <path
                    fill="#D8D8D8"
                    fill-rule="evenodd"
                    d="M25 7c1.657 0 3-1.344 3-3 0-1.657-1.343-3-3-3s-3 1.343-3 3c0 .966.457 1.826 1.166 2.374l-3.71 8.66C19.305 15.01 19.154 15 19 15c-.856 0-1.628.358-2.175.933l-3.92-2.178c.062-.241.095-.494.095-.755 0-1.657-1.343-3-3-3s-3 1.343-3 3c0 .791.307 1.511.808 2.048l-3.88 6.098C3.634 21.05 3.323 21 3 21c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3c0-.792-.307-1.512-.808-2.048l3.88-6.098c.293.094.604.146.928.146.856 0 1.628-.359 2.175-.934l3.92 2.178c-.062.242-.095.495-.095.756 0 1.657 1.343 3 3 3s3-1.343 3-3c0-.967-.457-1.826-1.166-2.375l3.711-8.66c.148.023.3.035.455.035zm1.75-3c0 .966-.784 1.75-1.75 1.75S23.25 4.966 23.25 4c0-.967.784-1.75 1.75-1.75s1.75.783 1.75 1.75zm-6 14c0 .966-.784 1.75-1.75 1.75s-1.75-.784-1.75-1.75c0-.967.784-1.75 1.75-1.75s1.75.783 1.75 1.75zm-9-5c0 .966-.784 1.75-1.75 1.75S8.25 13.966 8.25 13c0-.967.784-1.75 1.75-1.75s1.75.783 1.75 1.75zm-7 11c0 .966-.783 1.75-1.75 1.75-.966 0-1.75-.784-1.75-1.75 0-.967.784-1.75 1.75-1.75.967 0 1.75.783 1.75 1.75z"
                    clip-rule="evenodd"
                  />
                  <mask id="tz0kygkxta" width="28" height="27" x="0" y="0" maskUnits="userSpaceOnUse">
                    <path
                      fill="#fff"
                      fill-rule="evenodd"
                      d="M25 7c1.657 0 3-1.344 3-3 0-1.657-1.343-3-3-3s-3 1.343-3 3c0 .966.457 1.826 1.166 2.374l-3.71 8.66C19.305 15.01 19.154 15 19 15c-.856 0-1.628.358-2.175.933l-3.92-2.178c.062-.241.095-.494.095-.755 0-1.657-1.343-3-3-3s-3 1.343-3 3c0 .791.307 1.511.808 2.048l-3.88 6.098C3.634 21.05 3.323 21 3 21c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3c0-.792-.307-1.512-.808-2.048l3.88-6.098c.293.094.604.146.928.146.856 0 1.628-.359 2.175-.934l3.92 2.178c-.062.242-.095.495-.095.756 0 1.657 1.343 3 3 3s3-1.343 3-3c0-.967-.457-1.826-1.166-2.375l3.711-8.66c.148.023.3.035.455.035zm1.75-3c0 .966-.784 1.75-1.75 1.75S23.25 4.966 23.25 4c0-.967.784-1.75 1.75-1.75s1.75.783 1.75 1.75zm-6 14c0 .966-.784 1.75-1.75 1.75s-1.75-.784-1.75-1.75c0-.967.784-1.75 1.75-1.75s1.75.783 1.75 1.75zm-9-5c0 .966-.784 1.75-1.75 1.75S8.25 13.966 8.25 13c0-.967.784-1.75 1.75-1.75s1.75.783 1.75 1.75zm-7 11c0 .966-.783 1.75-1.75 1.75-.966 0-1.75-.784-1.75-1.75 0-.967.784-1.75 1.75-1.75.967 0 1.75.783 1.75 1.75z"
                      clip-rule="evenodd"
                    />
                  </mask>
                  <g mask="url(#tz0kygkxta)">
                    <path fill="#9B9B9B" d="M0 0H28V28H0z" />
                  </g>
                </svg>
                <span v-translate:DASHBOARD_TITLE="lang">Dashboard</span>
              </span>
            </li>
            <li class="nav-item mr-30 nav_link_li">
              <span class="nav-link" :class="$route.name == 'participants-portal-learn' ? 'participant-portal-active-link' : ''" @click="learnPage()">
                <svg class="header-menu_icons" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 33 33">
                  <path
                    fill="#9B9B9B"
                    d="m30.836,12.29491l-12.59,5.18038c-0.476,0.1971 -1.104,0.29497 -1.732,0.29497c-0.628,0 -1.256,-0.09787 -1.733,-0.29497l-12.59,-5.18038c-0.953,-0.39148 -0.953,-1.03308 0,-1.42593l12.59,-5.18038c0.477,-0.1971 1.105,-0.29497 1.733,-0.29497c0.628,0 1.256,0.09787 1.732,0.29497l12.59,5.18038c0.953,0.39284 0.953,1.03444 0,1.42593l0,0zm-5.135,13.14464c0,0 -1.855,2.89536 -9.187,2.89536c-7.332,0 -9.188,-2.89536 -9.188,-2.89536l0,-9.29776l9.188,3.87951l9.187,-3.87951l0,9.29776zm-22.672,0.28274l-1.444,0l0,-2.05258l0.722,-1.70459l0.722,1.70459l0,2.05258zm28.156,-16.40838l-12.591,-5.18038c-0.57,-0.23516 -1.309,-0.3643 -2.08,-0.3643c-0.771,0 -1.51,0.12914 -2.081,0.3643l-12.59,5.18038c-1.361,0.5614 -1.565,1.66245 -1.565,2.26871c0,0.58451 0.19,1.63255 1.43,2.20754l0,6.329l-1.321,3.11693l0,4.11059l3.84,0l0,-4.11059l-1.321,-3.11693l0,-5.83285l3.222,1.3267l0,0.52878l0,9.29776l0,0.60762l0.294,0.45809c0.227,0.35342 2.435,3.45404 10.092,3.45404c7.657,0 9.865,-3.10061 10.091,-3.45404l0.294,-0.45809l0,-0.60762l0,-9.29776l0,-0.52878l4.285,-1.76304c1.362,-0.56004 1.565,-1.66109 1.565,-2.26735c0,-0.60626 -0.203,-1.70731 -1.564,-2.26871l0,0z"
                  />
                </svg>
                <span v-translate:LEARN_TITLE="lang">Learn</span>
              </span>
            </li>
            <li class="nav-item mr-30">
              <span class="nav-link" :class="$route.path.includes('profile/') || $router.currentRoute.name == 'participants-portal-profile' ? 'participant-portal-active-link' : ''" @click="profilePage()">
                <svg class="header-menu_icons" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 28 28">
                  <path
                    fill="#9B9B9B"
                    d="M14 1.272C21 1.272 26.727 7 26.727 14S21 26.727 14 26.727 1.273 21 1.273 14 7 1.272 14 1.272zM14 0C6.279 0 0 6.278 0 14c0 7.72 6.279 14 14 14s14-6.28 14-14c0-7.722-6.279-14-14-14zm2.46 12.77c1.061-.764 1.782-2.037 1.782-3.437C18.242 7 16.333 5.091 14 5.091S9.758 7 9.758 9.333c0 1.4.678 2.673 1.781 3.436-3.012 1.146-5.175 4.03-5.175 5.897.848 2.546 4.242 3.819 7.636 3.819s6.788-1.273 7.636-3.819c0-1.866-2.163-4.751-5.175-5.897zm-5.43-3.437c0-1.655 1.315-2.97 2.97-2.97 1.655 0 2.97 1.315 2.97 2.97 0 1.655-1.315 2.97-2.97 2.97-1.655 0-2.97-1.316-2.97-2.97zM14 21.212c-3.097 0-5.642-1.103-6.364-2.758.212-1.612 2.843-4.879 6.364-4.879s6.151 3.267 6.364 4.88c-.722 1.654-3.267 2.757-6.364 2.757z"
                  />
                </svg>
                <span v-translate:PROFILE_TITLE="lang">Profile</span>
              </span>
            </li>
          </ul>
        </div>
        <div class="col-md-2 notify_icon_sec" v-if="participant.active">
          <div class="d-flex justify-content-end icon_div">
            <div class="icon cursor_pointer">
              <a @click="$refs.childref.onClickNotification()" v-translate:NOTIFICATION_TITLE.title="lang" title="Notifications" class="d-inline-block" data-toggle="modal" data-target="#NotificationModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="36" fill="none" viewBox="0 0 34 36">
                  <path
                    fill="var(--primary)"
                    d="M15.469 8.42l-.482-3.344c-.028-.192.021-.387.137-.543.115-.155.288-.258.48-.286.192-.028.387.021.542.137.156.115.259.288.287.48l.482 3.352c-.234.015-.475.044-.723.08-.248.037-.49.08-.723.125zM5.304 21.66c-.194.006-.377.088-.51.23-.132.14-.203.329-.197.523.042 1.63-.372 3.239-1.196 4.646-.055.082-.093.175-.111.273-.018.098-.016.198.006.295.022.097.063.189.122.269.058.08.133.148.218.198.086.05.18.083.28.096.098.012.198.005.294-.023.095-.027.184-.074.26-.137.078-.063.141-.14.187-.23.963-1.644 1.448-3.525 1.4-5.43-.002-.097-.023-.192-.063-.28-.039-.088-.095-.167-.165-.233s-.153-.118-.243-.152c-.09-.033-.186-.049-.282-.045zm16.31-16.421c2.064.715 3.88 2.008 5.234 3.724.12.152.297.25.49.27.192.023.385-.033.537-.154.151-.12.249-.296.27-.49.022-.192-.033-.385-.154-.537-1.524-1.93-3.57-3.385-5.894-4.19-.183-.065-.384-.054-.558.03-.175.084-.309.234-.373.417-.064.183-.053.384.031.558.084.175.234.309.417.373v-.001zM8.235 21.659c-.193.005-.377.086-.51.226-.135.14-.207.327-.203.521.056 2.49-.699 4.931-2.15 6.956-.12.151-.176.345-.154.537.022.193.12.368.272.489.151.12.345.176.537.154.193-.023.369-.12.489-.272 1.653-2.298 2.518-5.07 2.463-7.9-.006-.193-.087-.376-.226-.509-.14-.133-.325-.206-.518-.202zM20.767 8.036c1.26.468 2.391 1.225 3.304 2.21.065.073.144.132.232.174.087.042.183.066.28.07.097.005.195-.01.286-.044.091-.034.175-.085.246-.152.071-.066.128-.146.168-.235.04-.089.062-.185.064-.282.002-.098-.016-.194-.051-.285-.036-.09-.09-.173-.158-.243-1.067-1.15-2.39-2.035-3.862-2.581-.09-.034-.185-.05-.281-.046-.096.003-.19.026-.277.066-.088.04-.166.096-.232.166-.065.07-.116.153-.15.243-.033.09-.049.185-.045.28.003.097.025.191.065.278.04.088.096.166.167.232.07.065.152.116.242.15h.002zm10.736 16.187c-1.82-1.793-3-4.134-3.36-6.663-.025-.192-.126-.366-.28-.484-.154-.117-.349-.169-.54-.143-.193.026-.367.127-.484.28-.118.154-.17.349-.144.541.404 2.85 1.733 5.488 3.782 7.508.138.136.325.212.518.211.194-.001.38-.08.516-.217.136-.138.212-.324.21-.518 0-.193-.079-.379-.217-.515h-.001zm-6.241-6.083c-.475-3.549-1.592-6.01-3.323-7.317-1.402-1.06-3.214-1.417-5.543-1.081-2.33.336-3.966 1.183-5.01 2.6-1.293 1.738-1.673 4.418-1.125 7.96.492 3.283-.056 6.638-1.567 9.593-.056.112-.082.236-.076.36.005.126.043.247.109.353.066.106.158.193.267.253.11.06.232.092.357.091 1.753-.021 4.224-.105 6.883-.353.053-.008.107-.013.16-.014h.023c.964-.088 1.942-.205 2.928-.343.986-.14 1.965-.307 2.914-.497h.008c.042-.014.086-.022.131-.022 2.636-.52 5.044-1.143 6.738-1.62.12-.034.23-.098.319-.187.088-.088.152-.198.185-.319.033-.12.034-.248.003-.37-.03-.12-.092-.232-.178-.322-2.285-2.41-3.755-5.475-4.203-8.765zm-8.027 13.832c.15.467.44.876.833 1.169.347.262.76.423 1.192.466.433.042.87-.035 1.26-.225.392-.19.723-.484.958-.85s.364-.79.373-1.224c-.752.146-1.526.27-2.3.38-.774.11-1.548.204-2.315.284z"
                  />
                </svg>
              </a>
              <div class="notification-count">
                <span class="pr-4 p-4" v-show="notifyCount > 0">{{ notifyCount }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="responsive-size"></div>

      <!-- Yes Study -->
      <div class="confirmEmailModel">
        <div class="modal fade" id="NotificationModal" data-backdrop="static" data-keyboard="false">
          <div class="modal-dialog notibox" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <button type="button" class="close" @click="getNotification" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="verification">
                  <Notification v-if="participant.myStudyVersionId" ref="childref" :clickableTasks="clickableTasks" @notificationClicked="notificationClicked" @from-notify-data="getCountNotify"></Notification>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";
import LanguageCountry from "@/components/participant-portal/auth/language-countries";
import Notification from "../participant-portal/notification-list";
import { ParticipantPortal, Widget, Graph, Activities } from "@/components/services/participant-service";

export default {
  name: "portal-header",
  data() {
    return {
      date: new Date(),
      widget: new Widget(),
      portal: new ParticipantPortal(),
      graph: new Graph(),
      notifyCount: null,
      seen: false,
      headerOptions: this.options,
      hide() {
        this.seen = false;
      },
      show() {
        this.seen = true;
      },
      participantAddress: null,
      clickableTasks: ["survey", "epro", "telehealth", "resendDocument", "Document"],
      isManualResult: false,
      isLoginRouteName: false
    };
  },
  props: ["studyId", "globalElement", "options"],
  components: {
    Notification,
    LanguageCountry
  },
  computed: {
    ...mapGetters(["participant", "token"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    backBtnLinkOptions() {
      if (this.headerOptions && this.headerOptions.backRouterLink) {
        let backBtnRouterLink = { name: this.headerOptions.backRouterLink };
        if (this.headerOptions.backRouterParams) {
          backBtnRouterLink = Object.assign(backBtnRouterLink, {
            params: this.headerOptions.backRouterParams
          });
        }
        return backBtnRouterLink;
      } else {
        return false;
      }
    },
    getSiteName() {
      if (this.participantAddress) {
        let { name } = this.participantAddress;
        return name ? name.trim() : "";
      } else {
        return null;
      }
    },
    getAddress() {
      if (this.participantAddress) {
        let { address, city, country, state, zipcode } = this.participantAddress;
        const newAddress = address != null ? address : "";
        const newCity = city != null ? city : "";
        const newState = state != null ? state : "";
        const newCounter = country != null ? this.widget.translate("COUNTRY_" + country.toUpperCase().replace(" ", "_"), country) : "";
        const newZipCode = zipcode != null ? zipcode : "";
        let fullAddress = (newAddress ? newAddress + (newCity ? ", " : "") : "") + (newCity ? newCity + (newState ? ", " : "") : "") + (newState ? newState + (newCounter ? ", " : "") : "") + (newCounter ? newCounter + (newZipCode ? ", " : "") : "") + (newZipCode || "");
        return fullAddress.trim();
      } else {
        return "";
      }
    },
    getVideoCallSession() {
      return this.$store.getters.getParticipantTelehealthVideoCallDetails;
    }
  },
  watch: {
    options(val) {
      this.headerOptions = val;
    },
    "$route.name": {
      handler(newValue, oldValue) {
        this.isLoginRouteName = this.$route.name != "participants-portal-auth-login";
        if (oldValue === "participants-portal-auth-join" && newValue === "participants-web-join") {
          window.location.reload();
        }
      },
      deep: true
    },
    "$route.params.studyId": {
      handler(val) {
        if (val) {
          this.$store.dispatch("loadParticipantWebVideosToStore", val);
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$root.$on("isManual_Notification", result => {
      this.isManualResult = result;
    });
    /** When dynamically added activity's push notification is clicked. */
    this.dynamicActivityNotificationClicked();
    /** Check if Participant is already logged in */
    if (this.participant.pid !== "" && (this.$route.params.studyId != this.portal.getStudy() || this.participant.studyId != this.portal.getStudy())) {
      this.$store.dispatch("participantLogout");
    }
    this.$root.$on("readNotification", () => {});
    this.$root.$on("notification-activity-loaded", () => {
      $("#NotificationModal").modal("hide");
    });
    this.$root.$on("showSiteLocation", async () => {
      this.$api.getParticipantAddress(this.participant.pid).then(res => {
        const { address, city, state, country, zipcode } = res.body;
        let addressStr = "https://maps.google.com/?q=" + address + "," + city + "," + state + "," + country + "&address=" + zipcode;
        addressStr = encodeURI(addressStr);
        window.open(addressStr, "_blank");
      });
    });
    navigator.serviceWorker.addEventListener("message", event => {
      if (event.data.type == "manualStudyStartDay" && this.$route.name != "participants-portal-activity-list") {
        this.$router.push({
          name: "participants-portal-activity-list",
          params: { studyId: this.portal.getStudy() }
        });
      }
    });
    moment.locale(this.lang);
  },
  methods: {
    ...mapActions(["participantLogout"]),
    notificationClicked(notifyObj) {
      const selectedDate = moment(notifyObj.notificationTriggeredTime);
      let activities = [];
      const startDay = this.portal.getDayFromDate(notifyObj.notificationTriggeredTime);

      if (this.clickableTasks.includes(notifyObj.taskType)) {
        if (notifyObj.eventType == "th_appointment") {
          if (this.getVideoCallSession && this.getVideoCallSession.appointmentId == notifyObj.taskInstanceId) {
            this.$root.$emit("showVideoCall", {
              show: true,
              notifyObj: notifyObj
            });
            $("#NotificationModal").modal("hide");
            return;
          }
          if (this.$store.getters.getParticipantsAppointmentStatus && this.$store.getters.getParticipantsAppointmentStatus.appointmentId && this.$store.getters.getParticipantsAppointmentStatus.appointmentId == notifyObj.taskInstanceId) {
            this.$root.$emit("JoinVideoCall", {
              appointmentDetails: this.$store.getters.getParticipantsAppointmentStatus,
              notifyObj: notifyObj
            });
            $("#NotificationModal").modal("hide");
            return;
          }
        } else if (notifyObj.taskType == "resendDocument") {
          $("#NotificationModal").modal("hide");
          const currentDate = new Date(); //Added this query param to detect the route change when a user is already on documents screen
          this.$router.push({
            name: "participants-portal-profile-documents",
            query: { from: `notification-list-${currentDate.getTime()}` }
          });
          return;
        } else if (notifyObj.taskType == "Document") {
          $("#NotificationModal").modal("hide");
          this.$router.push({ name: "participants-portal-activities" });
          return;
        }
        const activityObject = new Activities();
        activities = activityObject.getScheduledActivities(selectedDate.toDate());
        const taskIdList = activities.map(o => o.taskId);
        const scheduleObj = this.$store.getters.getParticipantStudyTaskSchedules;
        const postData = {
          taskIdList: taskIdList,
          schedule: { schedules: scheduleObj }
        };
        this.$api.getPortalDashboardData(this.participant.pid, this.$route.params.studyId, startDay, { participantId: this.participant.pid, web: true }, postData).then(response => {
          const activityDataMap = response.data.map(o => o.taskId);
          const that = {
            activityDataMap: activityDataMap,
            activityDataList: response.data
          };
          activities = activities.map(o => {
            if (that.activityDataMap.includes(o.taskId)) {
              const thisTask = that.activityDataList.find(i => i.taskId == o.taskId);
              o.completedCount = thisTask.completedCount;
              o.scheduledCount = thisTask.scheduledCount;
            }
            return o;
          }, that);
          const activity = activities.find(item => item.taskInstanceId == notifyObj.taskInstanceId);
          if (activity) {
            if (activity.taskType == "telehealth") {
              if (!this.isOnSameActivity("participants-portal-activity-telehealth-details", activity)) {
                this.$router.push({
                  name: "participants-portal-activity-telehealth-details",
                  params: {
                    studyId: this.studyId,
                    taskId: activity.taskId,
                    activity: activity,
                    notification: this.notifyObject
                  }
                });
              }
              return;
            }
            if (activity.allowMultiple || (activity.allowMultiple == false && activity.completedCount == 0)) {
              const taskSchedules = this.$store.getters.getParticipantTaskSchedules.filter(o => o.startDay >= startDay && startDay <= o.endDay);
              const selectedSchedule = taskSchedules.find(o => o.taskId + "_" + startDay == activity.taskId + "_" + startDay);
              let selectedActivity = this.$store.getters.getParticipantAdherences.find(o => o.taskId == activity.taskId);
              if (selectedActivity == undefined) {
                selectedActivity = {
                  completedCount: 0,
                  participantId: this.participant.pid,
                  scheduledCount: startDay == 0 ? 1 : startDay,
                  siteId: null,
                  siteName: null,
                  studyId: this.studyId,
                  taskId: activity.taskId,
                  taskName: activity.taskTitle,
                  taskType: activity.taskType
                };
              }
              this.$store.dispatch("setParticipantSelectedActivity", Object.assign(selectedActivity, selectedSchedule));
              if (!this.isOnSameActivity("participants-portal-activity-details", activity)) {
                this.$router.push({
                  name: "participants-portal-activity-details",
                  params: {
                    taskType: activity.taskType,
                    taskId: activity.taskId,
                    taskInstanceId: activity.taskInstanceId,
                    notification: notifyObj
                  }
                });
              }
            } else {
              const message = this.widget.translate("completed_activity_error_meassege", "This activity has either been completed or is no longer available.");
              this.$toastr.warning(message);
              return;
            }
          } else {
            const message = this.widget.translate("completed_activity_error_meassege", "This activity has either been completed or is no longer available.");
            this.$toastr.warning(message);
            return;
          }
        });
      } else {
        const message = this.widget.translate("activity_not_supported", "Task not supported.");
        this.$toastr.error(message);
        return;
      }
    },
    isOnSameActivity(routename, activity) {
      if ((this.$route.name === "participants-portal-activity-details" && this.$route.params.taskInstanceId === activity.taskInstanceId) || (this.$route.name === "participants-portal-activity-telehealth-details" && this.$route.params.activity.taskInstanceId === activity.taskInstanceId)) {
        $("#NotificationModal").modal("hide");
        return true;
      } else {
        return false;
      }
    },
    clearSingleNotification(notifyObj) {
      try {
        let rawData = {
          deleteAllFlag: true,
          offset: moment().format("Z"),
          scheduleDay: this.graph.getUserDay()
        };
        this.$api.putParticipantsClearNotifications({ notificationId: notifyObj.notificationId, isWeb: true }, this.participant.pid, rawData).then(() => {});
      } catch (error) {
        const message = this.widget.translate(error.message, this.lang);
        this.$toastr.error(message);
      }
    },
    async onParticipantAddress() {
      this.seen = true;
      let address = await this.$api.getParticipantAddress(this.participant.pid);
      this.participantAddress = address.body;
    },
    activityPage() {
      this.$router.push({ name: "participants-portal-activities" });
    },
    profilePage() {
      this.$router.push({ name: "participants-portal-profile" });
    },
    dashboardPage() {
      this.$router.push({ name: "participants-portal-dashboard" });
    },
    learnPage() {
      this.$router.push({ name: "participants-portal-learn" });
    },
    goToNotifications() {
      this.$router.push({ name: "participants-portal-notifications" });
    },
    getCountNotify(value) {
      this.notifyCount = value;
    },
    onBackBtnClick() {
      this.$emit("onBackBtnClick", true);
      setTimeout(() => {
        this.$emit("onBackBtnClick", false);
      }, 3000);
    },
    onCancelClick() {
      this.$emit("onCancel", false);
    },
    onClickBackBtnSamePage(link) {
      if (link !== false) {
        this.$router.push(link);
      }
    },
    onCallStudySite() {
      if (this.participantAddress && this.participantAddress.phoneNumber) {
        window.open("tel:" + this.participantAddress.phoneNumber);
      } else {
        let message = this.widget.translate("no_available_contact_number", "Site phone number is not available");
        if (message) {
          this.$toastr.error(message);
        }
      }
    },
    getNotification() {
      if (this.isManualResult) {
        this.$root.$emit("trigger_Notification", { page: 1, status: false });
      }
    },
    dynamicActivityNotificationClicked() {
      try {
        if ("serviceWorker" in navigator && navigator.serviceWorker) {
          navigator.serviceWorker.onmessage = event => {
            if (event && event.data && event.data.action === "notification-click-dynamically-added-activity") {
              this.$router.push({ name: "participants-portal-activities" });
            }
          };
        }
      } catch (err) {}
    }
  },
  directives: {
    clickoutside: {
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind: function(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
      stopProp(event) {
        event.stopPropagation();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.header-style {
  margin-top: 15px;
  padding: 10px 24px;
  border: solid 1px #d8e3e7;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: none !important;
}
.profile-header .nav-link img {
  width: 20px;
  margin-right: 4px;
}
.profile-header {
  margin-top: 30px;
}

.icon_div {
  position: relative;
  top: 0;
}
/* Help icons*/
.help-container {
  width: 402px;
  height: auto;
  top: 10px;
  left: -25px;
  border-radius: 4px;
  padding: 48px 60px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
  position: absolute;
  z-index: 3;
}
.help-container-relative {
  position: relative;
}
.help-container .help-nameText {
  font-family: Roboto;
  font-size: 24px;
  padding-bottom: 24px;
  font-weight: bold;
  text-align: center;
  letter-spacing: -0.41px;
  color: #4a4a4a;
}
.help-container .help-addressText {
  font-family: Roboto;
  font-size: 24px;
  text-align: center;
  font-weight: normal;
  letter-spacing: -0.41px;
  color: var(--secondary);
  overflow-wrap: break-word;
}
.help_call_studySite {
  width: 100%;
  height: 50px;
  padding: 12px 15px;
  border-radius: 10px;
  background-color: var(--secondary);
  color: #fff;
  margin-top: 30px;
  text-transform: capitalize;
}
</style>
